import { GDnTDatatype } from "../../interface/dataTypeInterface";
import straightnessImg from "../../img/data-gdnt-straightness.png";
import flatnessImg from "../../img/data-gdnt-flatness.png";
import circularityImg from "../../img/data-gdnt-circularity.png";
import cylindicityImg from "../../img/data-gdnt-cylindicity.png";
import profileLineImg from "../../img/data-gdnt-profile_line.png";
import profileSurfaceImg from "../../img/data-gdnt-profile_surface.png";
import angularityImg from "../../img/data-gdnt-angularity.png";
import parallelismImg from "../../img/data-gdnt-parallelism.png";
import perpendicularityImg from "../../img/data-gdnt-perpendicularity.png";
import positionImg from "../../img/data-gdnt-position.png";
import circularRunoutImg from "../../img/data-gdnt-circular_runout.png";
import totalRunoutImg from "../../img/data-gdnt-total_runout.png";

// data from https://www.gd-t.com/_files/ugd/b369f6_a3a91bb28c7d4aabb8c88688bf611ad3.pdf

export const gdntData: GDnTDatatype[] = [
  {
    name: "GD&T controls",
    id: "gdnt",
    descriptions: [
      '"Geometrical Dimensioning and Tolerancing - Tolerancing of form, orientation, location and run-out.” In short, “geometrical product specifications” refer to the shape, size, and positional relationship of a product, while “tolerance” means the allowable error.',
    ],
    updatedAt: "2022-07-26",
    data: [
      {
        control_category: { value: "form" },
        control_name: { value: "straightness" },
        control_symbol: { value: straightnessImg, isImg: true },
        description: {
          value: "2 parallel lines or a single cylinder",
        },
      },
      {
        control_category: { value: "form" },
        control_name: { value: "flatness" },
        control_symbol: { value: flatnessImg, isImg: true },
        description: {
          value: "2 parallel planes",
        },
      },
      {
        control_category: { value: "form" },
        control_name: { value: "circularity" },
        control_symbol: { value: circularityImg, isImg: true },
        description: {
          value: "2 coaxial circles",
        },
      },
      {
        control_category: { value: "form" },
        control_name: { value: "cylindicity" },
        control_symbol: { value: cylindicityImg, isImg: true },
        description: {
          value: "2 coaxial cylinders",
        },
      },
      {
        control_category: { value: "profile" },
        control_name: { value: "profile of a line" },
        control_symbol: { value: profileLineImg, isImg: true },
        description: {
          value: "2 offset line (shape) elements",
        },
      },
      {
        control_category: { value: "profile" },
        control_name: { value: "profile of a surface" },
        control_symbol: { value: profileSurfaceImg, isImg: true },
        description: {
          value: "2 offset surfaces",
        },
      },
      {
        control_category: { value: "orientation" },
        control_name: { value: "angularity" },
        control_symbol: { value: angularityImg, isImg: true },
        description: {
          value: "2 parallel lines, 2 parallel planes, or a single cylinder",
        },
      },
      {
        control_category: { value: "orientation" },
        control_name: { value: "parallelism" },
        control_symbol: { value: parallelismImg, isImg: true },
        description: {
          value: "2 parallel lines, 2 parallel planes, or a single cylinder",
        },
      },
      {
        control_category: { value: "orientation" },
        control_name: { value: "perpendicularity" },
        control_symbol: { value: perpendicularityImg, isImg: true },
        description: {
          value: "2 parallel lines, 2 parallel planes, or a single cylinder",
        },
      },
      {
        control_category: { value: "location" },
        control_name: { value: "position" },
        control_symbol: { value: positionImg, isImg: true },
        description: {
          value: "2 parallel planes, a cylinder, a sphere, or other shapes",
        },
      },
      {
        control_category: { value: "runout" },
        control_name: { value: "circular runout" },
        control_symbol: { value: circularRunoutImg, isImg: true },
        description: {
          value: "2 coaxial circles",
        },
      },
      {
        control_category: { value: "runout" },
        control_name: { value: "total runout" },
        control_symbol: { value: totalRunoutImg, isImg: true },
        description: {
          value: "2 coaxial cylinders, or two parallel planes",
        },
      },
    ],
  },
];
